export default {
  button: {
    ADD_CUSTOMER: 'Tambah Customer',
    UPLOAD_ALL: 'Unggah Sekaligus',
  },
};
